<script setup>
import { ref } from 'vue';
import { notification } from 'ant-design-vue';
import BaseModalEdit from '@/components/base/BaseModalEdit.vue';
import { updateAdmin } from '@/api/admin/updateAdmin';

const props = defineProps({
    open: {
        type: Boolean,
        default: false
    },
    managerData: {
        type: Object,
        default: () => ({})
    }
});

const emit = defineEmits(['update:open', 'success']);

const loading = ref(false);

// 表單項目定義
const formItems = [
    {
        label: '姓名',
        key: 'name',
        placeholder: '姓名'
    },
    {
        label: '信箱',
        key: 'email',
        placeholder: '請輸入信箱',
        inputType: 'email',
        rules: [
            { type: 'email', message: '請輸入有效的信箱格式', trigger: 'blur' }
        ]
    },
    {
        label: '密碼',
        key: 'password',
        placeholder: '請輸入密碼',
        inputType: 'password'
    }
];

// 處理表單提交
const handleSubmit = async (formData) => {
    loading.value = true;

    try {
        const response = await updateAdmin(props.managerData.id, formData);

        if (response.status === 1) {
            emit('success', response.data);
            emit('update:open', false);
        } else {
            // 處理業務邏輯錯誤
            notification.error({
                message: '編輯失敗',
                description: response.message || '編輯管理員資料時發生錯誤'
            });
        }
    } catch (error) {
        console.error('編輯管理員 API 錯誤:', error);

        // 處理 HTTP 422 錯誤
        if (error.response?.status === 422) {
            const errorData = error.response.data;
            if (errorData.errors) {
                const errorMessages = Object.values(errorData.errors)
                    .flat()
                    .join(', ');
                notification.error({
                    message: '驗證失敗',
                    description: errorMessages
                });
            } else {
                notification.error({
                    message: '編輯失敗',
                    description: errorData.message || '資料驗證失敗'
                });
            }
        } else {
            notification.error({
                message: '編輯失敗',
                description: '網路連線錯誤，請稍後再試'
            });
        }
    } finally {
        loading.value = false;
    }
};
</script>

<template>
    <BaseModalEdit
        :open="open"
        title="編輯管理員資料"
        :form-items="formItems"
        :initial-data="managerData"
        :loading="loading"
        :width="600"
        bodyHeight="auto"
        @update:open="$emit('update:open', $event)"
        @submit="handleSubmit"
    />
</template>
